import API from "./axiosConfig";
import { safeHttpErrorLog } from "../utils/errorHandler";
import { shouldIgnoreUrlStatus } from "../config/signozConfig";

function buildResponse(response) {
  return response;
}

export default {
  postDataWithoutAuth: async (url, body) => {
    try {
      const response = await API.post(`${url}`, body);
      return buildResponse(response);
    } catch (err) {
      const status = err.response?.status || 500;
      const errorMessage = err.response?.data?.message || err.message || "Terjadi kesalahan";

      // Filter error yang tidak perlu di-trace ke SigNoz
      if (shouldIgnoreUrlStatus(url, status)) {
        console.warn(`⚠️ ${status} error for ${url} (not traced):`, errorMessage);
      } else {
        // Log error yang penting
        safeHttpErrorLog(err, url, status, { body });
      }

      // Tangani error dengan lebih baik untuk mencegah unhandled promise rejection
      return buildResponse(
        err.response ?? {
          status: 500,
          data: {
            message: "Terjadi kesalahan, silakan coba lagi nanti",
            success: false,
          },
        }
      );
    }
  },
  getDataWithoutAuth: async (url, parameter) => {
    try {
      const response = await API.get(`${url}`, {
        params: parameter,
      });
      return buildResponse(response);
    } catch (err) {
      const status = err.response?.status || 500;
      const errorMessage = err.response?.data?.message || err.message || "Terjadi kesalahan";

      // Filter error yang tidak perlu di-trace ke SigNoz
      if (shouldIgnoreUrlStatus(url, status)) {
        console.warn(`⚠️ ${status} error for ${url} (not traced):`, errorMessage);
      } else {
        // Log error yang penting
        safeHttpErrorLog(err, url, status, { parameter });
      }

      // Tangani error dengan lebih baik untuk mencegah unhandled promise rejection
      return buildResponse(
        err.response ?? {
          status: 500,
          data: {
            message: "Terjadi kesalahan, silakan coba lagi nanti",
            success: false,
          },
        }
      );
    }
  },
};
